/** All the possible headers for the member group projects table */
export let MemberGroupProjectsHeaders = /*#__PURE__*/function (MemberGroupProjectsHeaders) {
  /** Project thumbnail image */
  MemberGroupProjectsHeaders["thumbnail"] = "Thumbnail";
  /** Project name */
  MemberGroupProjectsHeaders["name"] = "Name";
  /** Project role */
  MemberGroupProjectsHeaders["role"] = "Project role";
  /** Whether the project role comes from a direct assignment or a team */
  MemberGroupProjectsHeaders["access"] = "Access";
  /** Any other possible options */
  MemberGroupProjectsHeaders["options"] = "Options";
  return MemberGroupProjectsHeaders;
}({});